module.exports = __webpack_public_path__ + "img/c4.1e0f45d3.png";